import { render, staticRenderFns } from "./DepBadge.vue?vue&type=template&id=0c221de0&scoped=true"
import script from "./DepBadge.vue?vue&type=script&lang=js"
export * from "./DepBadge.vue?vue&type=script&lang=js"
import style0 from "./DepBadge.vue?vue&type=style&index=0&id=0c221de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c221de0",
  null
  
)

export default component.exports